import { useState, useEffect } from 'react';

export default function HeroBanner() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Premium Rice Export Worldwide',
      subtitle: 'Quality rice varieties for global markets with export-grade packaging',
      cta: 'Get a Quote',
      image: 'https://public.readdy.ai/ai/img_res/88e2b912fa235ae0a85466b51226d62d.jpg'
    },
    {
      title: 'Reliable Bulk Supply & Timely Delivery',
      subtitle: 'MOQ 25 Ton - Building trust through consistent quality and on-time shipments',
      cta: 'Contact Us',
      image: 'https://readdy.ai/api/search-image?query=modern%20cargo%20shipping%20containers%20and%20logistics%20warehouse%20with%20organized%20export%20packages%20and%20quality%20control%20setting%20clean%20professional%20minimal%20background%20representing%20reliable%20global%20trade&width=1920&height=1080&seq=hero3&orientation=landscape'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleCTA = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>

          <div className="relative h-full flex items-center justify-center">
            <div className="container mx-auto px-4 text-center">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                {slide.title}
              </h1>
              <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
                {slide.subtitle}
              </p>
              <button
                onClick={handleCTA}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {slide.cta}
              </button>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}
